<template>
    <div class="flex flex-col px-8">
        <div v-if="isLoading" class="h-full flex flex-col justify-center items-center">
            <base-spinner></base-spinner>
        </div>
        <div v-else-if="!isLoading && !hasItems" class="h-full flex justify-center items-center">
            <h1 class="text-center text-xl font-medium py-16">No students found!</h1>
        </div>
        <div v-else class="flex flex-col">
            <div class="flex flex-col overflow-x-auto">
                <div class="inline-block min-w-full py-2">
                    <div class="overflow-x-auto">
                        <table class="min-w-full text-left text-sm font-light">
                            <thead class="border-b font-medium dark:border-neutral-500">
                                <tr>
                                    <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Student</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Student ID</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Entity</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items" :key="index" class="border-b border-dashed dark:border-neutral-500">
                                    <td class="whitespace-nowrap px-6 py-2 font-medium">{{ paginatorInfo.firstItem + index }}</td>
                                    <td class="whitespace-nowrap px-6 py-2">
                                        <div class="flex items-center">
                                            <div class="flex-shrink-0 mr-3">
                                                <img class="h-12 w-12 rounded-lg object-cover cursor-pointer" :src="getProfilePicture(item.student.student_id, item.student.entity)" alt="">
                                            </div>
                                            <div class="flex-grow flex flex-col mr-4">
                                                <h1 class="text-sm font-semibold flex items-center">
                                                    <span @click.stop="$emit('view-student-profile', item.student.student_id)" class="text-heading hover:text-blue-600 hover:underline cursor-pointer">{{ item.student.name_en }}</span>
                                                </h1>
                                                <p class="text-xs text-gray-400">{{ item.student.primary_email }}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="whitespace-nowrap px-6 py-2">{{ item.student.student_id }}</td>
                                    <td class="whitespace-nowrap px-6 py-2">{{ item.student.entity }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="mt-4">
                <pagination
                :paginatorInfo="paginatorInfo"
                :setPage="setPage"
                ></pagination>
            </div>
        </div>
    </div>
</template>

<script>
import gql from 'graphql-tag';
import Pagination from "../../components/shared/pagination.vue";
export default {
    name: 'internship-candidates',
    emits: ["view-student-profile"],
    props: ["internshipId"],
    components: {
        Pagination,
    },
    data() {
        return {
            isLoading: false,
            error: null,
            first: 10,
            page: 1,
            hasItems: false,
            items: [],
            paginatorInfo: [],
        };
    },
    created() {
        this.fetchStudentsList();
    },
    methods: {
        async fetchStudentsList() {
            
            this.isLoading = true;

            const GET_INTERNSHIP_CANDIDATES_QUERY = gql`
                query GetCandidatesListPerInternship($first: Int!, $page: Int!, $internship_id: Int!) {
                    getCandidatesListPerInternship(first: $first, page: $page, internship_id: $internship_id) {
                        error
                        error_code
                        message
                        data {
                            student {
                                student_id
                                name_en
                                entity
                                primary_email
                            }
                        }
                        paginatorInfo {
                            count
                            currentPage
                            firstItem
                            hasMorePages
                            lastItem
                            lastPage
                            perPage
                            total
                        }
                    }
                }
            `;

            try {
                await this.$apollo.query({
                    query: GET_INTERNSHIP_CANDIDATES_QUERY,
                    fetchPolicy: 'network-only',
                    variables: {
                        first: this.first,
                        page: this.page,
                        internship_id: parseInt(this.internshipId),
                    },
                }).then((data) => {
                    if (data.data.getCandidatesListPerInternship.error) {
                        this.error = data.data.getCandidatesListPerInternship.message;
                    } else {
                        this.items = data.data.getCandidatesListPerInternship.data;
                        this.paginatorInfo = data.data.getCandidatesListPerInternship.paginatorInfo;
                        this.hasItems = this.items.length > 0 ? true : false;
                    }
                }).catch((error) => {
                    this.error = error.message;
                })

            } catch (error) {
                this.error = error.message || "Please try again.";
            }

            this.isLoading = false;

        },
        getProfilePicture(studentId, entity) {
            return `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
        },
        setPage(page) {
            this.page = page;
            this.fetchStudentsList();
        },
    },
}
</script>